import React from "react";
import MyLink from "../components/Link";
import { Link } from "gatsby";
import { slug } from "../utils";

const toggleMenu = () => {
  if (typeof document === "undefined") return;
  const menu = document.getElementsByClassName("nav-menu")[0];
  const overlay = document.getElementsByClassName("nav-overlay")[0];
  if (overlay) overlay.classList.remove("active");
  if (menu) menu.classList.remove("menu-on");
};

const ParentLink = ({ item, onClick }) => {
  if (item.parent.type === "internal") {
    return (
      <Link
        to={slug(item.parent.link)}
        className="mobile-nav-link"
        onClick={onClick}
      >
        {item.parent.label}
      </Link>
    );
  }
  if (item.parent.type === "external") {
    return (
      <a
        href={item.parent.link}
        target="_blank"
        rel="noopener noreferrer"
        className="mobile-nav-link"
        onClick={onClick}
      >
        {item.parent.label}
      </a>
    );
  }
  return <span className="mobile-nav-link">{item.parent.label}</span>;
};

const MobileHeader = ({ list }) => {
  return (
    <nav className="main-menu d-block d-xl-none" aria-label="Mobile navigation">
      <ul>
        {(list || []).map((item, index) => {
          const hasChildren = item.childMenu?.length > 0;
          const subMenuId = `mobile-submenu-${index}`;

          return (
            <li
              className={`menu-item ${hasChildren ? "has-children" : ""}`}
              key={index}
            >
              {hasChildren ? (
                <details className="mobile-nav-details">
                  <summary className="mobile-nav-summary">
                    <ParentLink item={item} onClick={toggleMenu} />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="dd-trigger"
                      aria-hidden="true"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M6 9l6 6l6 -6" />
                    </svg>
                  </summary>
                  <ul id={subMenuId} className="sub-menu" role="group">
                    {item.childMenu.map((child, ind) => (
                      <li key={ind}>
                        <MyLink
                          link={child.link}
                          linkType={child.type}
                          text={child.label}
                          onClick={toggleMenu}
                        />
                      </li>
                    ))}
                  </ul>
                </details>
              ) : (
                <MyLink
                  link={item.parent.link}
                  linkType={item.parent.type}
                  text={item.parent.label}
                  onClick={toggleMenu}
                />
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileHeader;
